var exports = {
  "o": "groupHeaderContainer__KuBx86",
  "X": "groupHeaderContent__abDzzT",
};

module.exports = exports;
